import { financeApi } from "@bw/shared/api";

import { useFinanceContext } from "@/hooks/use-finance-context";
import { useMyFacilityActions } from "@/hooks/use-my-facility-actions";
import { useMyOrg } from "@/hooks/use-my-org";
import { useResolvedFacility } from "@/hooks/use-selected-facility";

/**
 * Whether money figures may be shown: internal facility reads
 * (facility:read_internal) at the selected facility, or org finance read.
 * Loading or missing hints fail closed; the server stays authoritative.
 */
export function useCanReadMoney(): boolean {
  const { facilityId } = useResolvedFacility();
  const { actions, isLoading } = useMyFacilityActions(facilityId);
  const view = useMyOrg();
  const finance = useFinanceContext(
    view.org?.org_id,
    financeApi,
    view.org?.finance_capability === "allowed",
  );
  const readInternal = !isLoading && actions.includes("facility:read_internal");
  const financeRead =
    finance.context?.allowed_actions.includes("org:finance_read") === true;
  return readInternal || financeRead;
}
